export default __webpack_public_path__ + "static/secondMobile-64b261c24672ba455e7018ee13951247.jpg";